<template lang="pug">
PageContent
  ul.page-bullet-list
    li(
      v-for="(item, index) in vList"
      :key="index"
      v-html="item"
    ) 
</template>

<script>
import _ from 'lodash'

export default {
  name: 'PageBulletList',
  props: {
    list: { type: String, default: '' },
  },
  computed: {
    vList() {
      if (_.isArray(this.list)) {
        return this.list
      }
      return String(this.list || '').split('\n')
    },
  },
}
</script>

<style lang="scss" scoped>
.page-bullet-list {
  font-size: 1.2em;
  line-height: 1.6;
  margin: 0.5em;
}
</style>
